import { ROUTER } from '../helpers/RouterApi';
import { BackEndHelper } from '../helpers/BackEndHelper';

export const CompaniesWithoutKeyContactsResultServices = {
    getList,
};

function getList() {
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_COMPANIES_WITHOUT_KEY_CONTACTS_RESULT);
}